import RestaurantPage from './RestaurantPage';

export default RestaurantPage;
